"use strict";

var _slicedToArray = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalState = void 0;

var react_1 = require("react");

function useLocalState(name, initial) {
  // for Gatsby build: https://www.gatsbyjs.com/docs/debugging-html-builds/#how-to-check-if-window-is-defined
  var storage = typeof window !== "undefined" ? window.localStorage : undefined;
  var initialWrapper = JSON.parse((storage === null || storage === void 0 ? void 0 : storage.getItem(name)) || "{}");
  var initialValue = (initialWrapper === null || initialWrapper === void 0 ? void 0 : initialWrapper.value) !== undefined ? initialWrapper === null || initialWrapper === void 0 ? void 0 : initialWrapper.value : initial;

  var _react_1$useState = react_1.useState(initialValue),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      get = _react_1$useState2[0],
      set = _react_1$useState2[1];

  return [get, function (value) {
    set(value);
    storage === null || storage === void 0 ? void 0 : storage.setItem(name, JSON.stringify({
      value: value
    }));
  }];
}

exports.useLocalState = useLocalState;